import React from "react";
import "./SideBarStyle.css";
import { MdAddCircle, MdChatBubbleOutline, MdDelete } from "react-icons/md";

const SideBarComponent = ({
  handleChangeProject,
  handleAddProject,
  handleDeleteProject,
  projects,
  isDark,
}) => {
  return (
    <>
      <section className={`side-bar ${isDark ? "side-bar-dark" : ""}`}>
        <div className="kanban-section-heading p-1">
          <h2>Projects</h2>
          <button
            className={`icn-btn-nobg ${
              isDark ? "icn-btn-nobg-dark" : ""
            } add-project`}
            onClick={handleAddProject}
          >
            <MdAddCircle size={22} />
          </button>{" "}
        </div>
        <div className="project-card-holder">
          {projects.map((project) => (
            <>
              <div
                id={project["projectId"]}
                onClick={handleChangeProject}
                className={`project-card ${isDark ? "project-card-dark" : ""}`}
              >
                <div className="project-title no-op">
                  <MdChatBubbleOutline size={24} />
                  &nbsp;&nbsp;
                  <p>{project.projectName}</p>
                </div>

                <button
                  className={`icn-btn-nobg ${
                    isDark ? "icn-btn-nobg-dark" : ""
                  } del-project`}
                  onClick={(e) => handleDeleteProject(e, project["projectId"])}
                >
                  <MdDelete size={20} />
                </button>
              </div>
            </>
          ))}
        </div>
      </section>
    </>
  );
};

export default SideBarComponent;
